<template>
  <v-container>
    <v-row align="center" justify="center" width="100%">
      <v-card light :flat="print" style="width: 28cm;">
        <v-card-text>
          <h1 style="line-height: 32px;" v-html="reportTitle"></h1>
          <v-row>
            <v-col xs="12" class="mt-1">
              <v-row>
                <v-col xs="6" class="text-right">
                  <img responsive :src="logoPath"/>
                  <br/>
                  <span v-html="contactInfo ? $root.newLineToBR(contactInfo) : null"></span>
                </v-col>
                <v-col xs="6">
                  <v-simple-table dense class="mb-5">
                    <template v-slot:default>
                      <tbody>
                      <tr>
                        <th class="text-left" colspan="2">
                          <h1>Totals</h1>
                        </th>
                      </tr>
                      <tr>
                        <td class="text-left">Loads Count</td>
                        <td class="text-left">{{totalsCounts.loads.toLocaleString()}}</td>
                      </tr>
                      <tr>
                        <td class="text-left">Total Miles</td>
                        <td class="text-left">{{totalsCounts.totalMiles.toLocaleString()}} {{$t('milesShort')}}</td>
                      </tr>
                      <tr v-if="isWithNet && totalsCounts.totalInitialRate">
                        <td class="text-left">Total Initial Rate</td>
                        <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalInitialRate.toFixed(2)).toLocaleString()}}</td>
                      </tr>
                      <tr v-if="isWithNet && totalsCounts.totalRateBonus">
                        <td class="text-left">Total Bonus</td>
                        <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalRateBonus.toFixed(2)).toLocaleString()}}</td>
                      </tr>
                      <tr v-if="totalsCounts.totalRate">
                        <td class="text-left">Total Rate</td>
                        <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalRate.toFixed(2)).toLocaleString()}}</td>
                      </tr>
                      <tr>
                        <td class="text-left">Avg Fees Percent</td>
                        <td class="text-left">{{totalsCounts.avgFeesPercent}}%</td>
                      </tr>
                      <tr v-if="totalsCounts.totalFees">
                        <td class="text-left">Total Fees Amount</td>
                        <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalFees.toFixed(2)).toLocaleString()}}</td>
                      </tr>
                      <tr v-if="totalsCounts.totalAdditionalPayments">
                        <td class="text-left">Total Additional Payments</td>
                        <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalAdditionalPayments.toFixed(2)).toLocaleString()}}</td>
                      </tr>
                      <tr v-if="totalsCounts.totalSalary">
                        <td class="text-left">Total Salary</td>
                        <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalSalary.toFixed(2)).toLocaleString()}}</td>
                      </tr>
                      <tr v-if="totalsCounts.totalPaidSalary">
                        <td class="text-left">Total Paid Salary</td>
                        <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalPaidSalary.toFixed(2)).toLocaleString()}}</td>
                      </tr>
                      <tr v-if="totalsCounts.totalSalary && totalsCounts.totalPaidSalary">
                        <td class="text-left">Total Not Paid Salary</td>
                        <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(parseFloat(totalsCounts.totalSalary-totalsCounts.totalPaidSalary).toFixed(2)).toLocaleString()}}</td>
                      </tr>
                      <tr v-if="isWithNet && totalsCounts.totalExpenses">
                        <td class="text-left">Total Expenses</td>
                        <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalExpenses.toFixed(2)).toLocaleString()}}</td>
                      </tr>
                      <tr v-if="isWithNet && totalsCounts.totalNet">
                        <td class="text-left">Total Net</td>
                        <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{parseFloat(totalsCounts.totalNet.toFixed(2)).toLocaleString()}}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <br/>
              <v-simple-table dense
                              style="border: 1px solid #000; width:100%;background: transparent;"
                              class="text-left">
                <tbody>
                <tr style="background:#015aaa;color:#fff;page-break-inside: avoid;">
                  <th class="report_font_size text-center">#</th>
                  <th class="report_font_size text-center">Started<br/>Ended</th>
                  <th class="report_font_size text-center">Locations</th>
                  <th class="report_font_size text-center">Trucks<br/>Drivers</th>
                  <th class="report_font_size text-center">Load Number<br/>Load UID</th>
                  <th class="report_font_size text-center">Rate</th>
                  <th class="report_font_size text-center">Fees</th>
                  <th class="report_font_size text-center" v-if="isWithNet">Addt.+Expn.</th>
                  <th class="report_font_size text-center" v-else>Additional.</th>
                  <th class="report_font_size text-center" v-if="isWithNet">Net</th>
                  <th class="report_font_size text-center">Salary</th>
                </tr>
                <tr v-for="item in entries" style="page-break-inside: avoid;">
                  <td>#{{item.id}}</td>
                  <td class="report_font_size">
                    <div class="text-no-wrap">{{item.startedPST}}</div>
                    <div class="text-no-wrap">{{item.endedPST}}</div>
                  </td>
                  <td class="report_font_size">
                    <div class="text-no-wrap" style="max-width: 150px; text-overflow: ellipsis; overflow: hidden;">
                      {{item.name.split('--')[0]}}
                    </div>
                    <div class="text-no-wrap" style="max-width: 150px; text-overflow: ellipsis; overflow: hidden;">
                      {{item.name.split('--')[1]}}
                    </div>
                  </td>
                  <td class="report_font_size">
                    <div class="text-no-wrap">{{item.truckName}}</div>
                    <div class="text-no-wrap">{{item.driverName}}</div>
                  </td>
                  <td class="report_font_size">
                    {{item.loadNumber}}
                    <br/>
                    {{item.uid}}
                  </td>
                  <td class="report_font_size">
                    <template v-if="item.initialRate && item.rateBonus && isWithNet">
                      {{parseFloat(item.initialRate.toFixed(2)).toLocaleString()}}-{{parseFloat(item.rateBonus.toFixed(2)).toLocaleString()}}=
                      <br/>
                      ${{parseFloat(parseFloat(item.initialRate-item.rateBonus).toFixed(2)).toLocaleString()}}
                    </template>
                    <template v-else>
                      ${{parseFloat(item.Rate.toFixed(2)).toLocaleString()}}
                    </template>
                  </td>
                  <td class="report_font_size">
                    <span>&nbsp;&nbsp;{{item.driverOwnerOperatorPercent}}%</span><br/>
                    <span class="text-no-wrap">${{parseFloat(parseFloat(item.Rate) * parseFloat(item.driverOwnerOperatorPercent / 100.0)).toFixed(2).toLocaleString()}}</span>
                  </td>
                  <td v-if="!isWithNet" class="report_font_size">
                  </td>
                  <td v-if="isWithNet" class="report_font_size">
                    ${{item.driverAdditionalPayments.toLocaleString()}} + ${{item.expenses.toLocaleString()}}
                  </td>
                  <td v-if="isWithNet" class="report_font_size">
                    ${{item.net.toLocaleString()}}
                  </td>
                  <td class="report_font_size" v-if="item.isPaid">
                    {{$t('Reports.Paid')}}&nbsp;${{item.driverSalary.toLocaleString()}}<br/><label class="report_font_size text-no-wrap">{{item.payedDateTime}}</label>
                  </td>
                  <td  class="report_font_size" v-else>
                    ${{item.driverSalary.toLocaleString()}}
                  </td>
                </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'DriverOOReportTemplate',
  props: ['entries', 'totalsCounts', 'print', 'from', 'to', 'driverName', 'isWithNet', 'companyId'],
  components: {},
  data: function () {
    return {
      byStatusCounts: {},
      publicPath: process.env.BASE_URL,
      contactInfo: '',
      logoPath: ''
    };
  },
  computed: {
    reportTitle () {
      let result = (this.driverName ? this.driverName : 'All Owner-Operators') + '<br/>' + this.$root.t('Report') + ' ' + (this.$route.params.report_number ? '#' + this.$route.params.report_number : '') + ': ';
      if (this.entries && this.entries.length > 1) {
        result += this.entries[0].startedPST.substring(0, 10) + ' - ' + this.entries[this.entries.length - 1].startedPST.substring(0, 10);
      }
      if (this.entries && this.entries.length === 1) {
        result += this.entries[0].startedPST.substring(0, 10);
      }
      return result;
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$root.getInvoiceLogoPath(this.companyId).then(path => {
        this.logoPath = path;
      });
      this.$root.getGlobalSettingsField('invoiceContactInfo', this.companyId).then((response) => {
        if (response.status === 'ok') {
          this.contactInfo = response.result;
        }
      });
      for (let i = 0; i < this.entries.length; i++) {
        const status = this.entries[i].status;
        if (!this.byStatusCounts.hasOwnProperty(status)) {
          this.byStatusCounts[status] = 0;
        }
        this.byStatusCounts[status] += 1;
      }
      this.$forceUpdate();
    });
    document.title = this.reportTitle.replace('<br/>', ' ');
  },
  methods: {
  }
};

</script>
